<template>
  <div class="memberSurvey" id="memberSurvey">
    <navbar/>
     <div class="modal">
      <div class="modal-content center-align text-center">
        <h4 v-html="errorMsg"></h4>
        <p><slot name="note"></slot></p>
      </div>
      <div class="modal-footer">
        <a class="modal-action blue modal-close waves-effect waves-ripple btn-flat center-align text-center" style="color: #fff !important;">close</a>
      </div>
    </div>
    <h4 class="text-xenter center-align">PLATINUM MINDS GLOBAL COMPANY</h4>
    <div class="surveyForm row">
       <h5>Please read the following instructions carefully before you proceed with the subsequent survey</h5>
      <div class="col s12 m9 white z-depth-1">
        <h4>Instructions</h4>
        <p class="instructionText">
          <ul>
            <li>&bull;&nbsp;&nbsp;All fields are required</li>
            <li>&bull;&nbsp;&nbsp;Full Name as in <br/><strong class="bold" style="font-weight: 600">Ekeh J. Chukwuemeka</strong> where <i class="bolder">Ekeh</i> is first name, <i class="bolder">J.</i> is middle name or other name initial, which can as well be written in full and <i class="bolder">Chukwuemeka</i> is last name.</li>
            <li>&bull;&nbsp;&nbsp;Ensure you enter correctly your full name in the format given above.</li>
            <li>&bull;&nbsp;&nbsp;A recent scanned copy of your photo preferrably studio photo, not more than three months old is required.</li>
            <li>&bull;&nbsp;&nbsp;Your description should be in form of third person pronoun</li>
            <li>&bull;&nbsp;&nbsp;Brief description and achievements must not be less than 300 characters.</li>
            <li>&bull;&nbsp;&nbsp;Ensure you include your country code along with your phone number.</li>
            <li>&bull;&nbsp;&nbsp;Ensure your attachments is successfully uploaded before you proceed to submit. Failure to do so invalidates your membership registration.</li>
          </ul>
        </p>
        <p class="note">NOTE: <br/> &bull;&nbsp;&nbsp;Attachments must not be greater than 160kb in size.<br/> &bull;&nbsp;&nbsp;The following file types are supported:<br/>
          <ul style="display: inline-flex;">
            <li>*jpg</li>,
            <li>*png</li>,
            <li>*bmp</li>
          </ul>
        </p>
      </div>
      <div class="col s12 m9 white z-depth-2">
        <h5>Members Survey</h5>
        <div class="row">
          <form class="col s12" @submit.prevent="validateForm" @input="errorMsg">
            <div class="row">
              <div class="input-field col m3 s5">
                <select v-model="formData.title" style="margin-top: 0.7rem;" required class="validate">
                  <option value="" disabled selected>Choose title</option>
                  <option v-for="(title, index) in titles" :key="index" :value="title.value">{{title.text}}</option>
                </select>
                <label class="active">Title</label>
              </div>
              <div class="input-field col s12 m6 push-m3">
                <input id="full_name" type="text" class="validate" required v-model="formData.fullName">
                <label for="full_name" >Full Name</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col m4 s12">
                <select style="margin-top: 0.7rem;" v-model="formData.gender" required class="validate">
                  <option value="" disabled>Choose your gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
                <label class="active">Gender</label>
                <!-- <p>
                  <label>
                    <input class="with-gap" type="radio" name="gender" v-model="formData.gender" id="male" value="male"/>
                    <span>Male</span>
                  </label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <label>
                    <input  type="radio" class="with-gap" name="gender" id="female" value="female" v-model="formData.gender"/>
                    <span>Female</span>
                  </label>
                </p> -->
              </div>
              <div class="input-field col m6 s12 push-m2">
                <input type="tel" id="phoneNo" class="validate" required v-model="formData.tel">
                <label for="phoneNo">Telephone</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col m6 s12">
                <input type="email" id="email" class="validate" required v-model="formData.email">
                <label for="email">Email Address</label>
              </div>
              <div class="input-field col s12 m6">
                <input id="guarantor_name" type="text" class="validate" required v-model="formData.guarantorName">
                <label for="guarantor_name" >Name of Guarantor/Next of kin</label>
              </div>
            </div>
            <div class="row">
               <div class="input-field col m6 s12">
                <input id="guarantor_no" type="tel" class="validate" required v-model="formData.guarantorNo">
                <label for="guarantor_no">Guarantor Phone No.</label>
              </div>
               <div class="file-field input-field col s12 m6">
                <div class="btn grey darken-3">
                  <span>Profile Photo</span>
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file">
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" type="text">
                </div>
                <br/>
                <small  class="center center-align text-center" v-if="isSaving">
                  <i class="fa fa-circle-o-notch fa-pulse x2 left white-text fa-2x" style="color: #fff !important; font-size: 2rem;"></i>
                  <i class="icon ion-loading-c"></i> Uploading...
                </small>
                <small v-if="isFailed" class="red-text">{{failText}}</small>
                <small v-if="isSuccess">Image successfully uploaded</small>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m10">
                <textarea id="description" class="validate materialize-textarea" required v-model="formData.briefDescription" placeholder="Minimum of 300 characters"></textarea>
                <label for="description" class="active">Brief Description and achievements</label>
                <span class="character-counter" style="float: right; font-size: 12px; height: 1px;"></span>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m6">
                <select id="country" required v-model="formData.country" @change="assignState" class="validate">
                  <option value="" disabled>Select Country --</option>
                  <option v-for="(allcountry, index) in allcountries" :key="index"  :value="allcountry.name">{{allcountry.name}}</option>
                </select>
                <label class="active" style="margin-top: -1rem;">Nationality</label>
              </div>
              <div class="input-field col s12 m6">
                <select id="region" required v-model="formData.state">
                  <option value="" disabled>Select Region --</option>
                  <option v-for="(allState, index) in allStates" :key="index" :value="allState.name">{{allState.name}}</option>
                </select>
                <label class="active" style="margin-top: -1rem;">State/Province</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12 m10">
                <textarea id="address" class="validate materialize-textarea" required v-model="formData.address" placeholder="Enter yor full address"></textarea>
                <label for="address" class="active">Residential Address</label>
              </div>
            </div>
            <p class="center-align text-center" id="p-text">
              <!-- <spinner id="spinner-survey"/><br/> -->
              <button type="submit" class="btn grey darken-3 center-align waves-effect" id="submitMemberDataBtn" @click="submitMemberData">Submit</button>
              <!-- a.btn.waves-effect.waves -->
            </p>
          </form>
        </div>
      </div>
    </div>
    <footer-page/>
  </div>
</template>

<script>
import Navbar from '@/components/layouts/navbar'
import FooterPage from '@/components/layouts/footer-page'
import countries from 'country-state-city'
import AddService from '@/services/addService'
import $ from 'jquery'
// import Spinner from 'vue-simple-spinner'
import * as axios from 'axios'
const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3
export default {
  components: {Navbar, FooterPage},
  mounted () {
    var elem = document.querySelector('.modal')
    // eslint-disable-next-line
    var instance = new M.Modal(elem, {})
    this.responseTrigger = instance
    this.reset()
    // document.getElementById('spinner-survey').style.display = 'none'
    $('#description').val('')
    $('#description').trigger('autoresize')
    $('#address').val('')
    $('#address').trigger('autoresize')

    this.allcountries = countries.getAllCountries()
  },
  props: {
    id: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      errorMsg: '',
      responseTrigger: '',
      responseNote: '',
      responseText: '',
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos',
      imgUrl: '',
      failText: '',
      titles: [
        {
          text: 'Mr',
          value: 'Mr.'
        },
        {
          text: 'Mrs',
          value: 'Mrs.'
        },
        {
          text: 'Miss',
          value: 'Miss.'
        },
        {
          text: 'Dr',
          value: 'Dr.'
        },
        {
          text: 'Dr Mrs',
          value: 'Dr. Mrs.'
        },
        {
          text: 'Prof',
          value: 'Prof.'
        }
      ],
      allcountries: [],
      allStates: [],
      formData: {
        title: '',
        fullName: '',
        email: '',
        gender: '',
        tel: '',
        guarantorName: '',
        guarantorNo: '',
        briefDescription: '',
        photoUrl: '',
        country: '',
        state: '',
        address: ''
      }
    }
  },
  methods: {
    toCapitalize (capitalizeMe) {
      let obtained = []
      let capitalizeVal = capitalizeMe.toLowerCase().split(' ')
      capitalizeVal.forEach(word => {
        let newWord = word.split('')
        newWord[0] = newWord[0].toUpperCase()
        newWord = newWord.join('')
        obtained.push(newWord)
      })
      capitalizeMe = obtained.join(' ')
      return capitalizeMe
    },
    isValidEmail (email) {
      if (!email || email === '') {
        return false
      }
      email = email.trim().toLowerCase()
      if (email === '' || !email) {
        return false
      }
      let regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i
      return regex.test(email)
    },
    validateForm (e) {},
    assignState () {
      this.allcountries.forEach(d => {
        if (d.name === this.formData.country) {
          this.countryId = d.id
        }
      })
      this.allStates = countries.getStatesOfCountry(this.countryId)
    },
    async submitMemberData () {
      let validateReg = {}
      if (this.formData.title) {
        validateReg.title = this.formData.title
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Title field is required'
        // console.log(this.errorMsg)
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.fullName && this.formData.fullName.length >= 7) {
        validateReg.fullName = this.formData.fullName
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please provide your full name.'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.gender) {
        validateReg.gender = this.formData.gender
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please select your gender.'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.tel) {
        validateReg.tel = this.formData.tel
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please provide your phone number.'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.email && this.isValidEmail(this.formData.email)) {
        validateReg.email = this.formData.email
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Invalid email address.'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.guarantorName && (this.formData.guarantorName.length >= 5)) {
        validateReg.guarantorName = this.formData.guarantorName
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please provide the name of next of kin'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.guarantorNo) {
        validateReg.guarantorNo = this.formData.guarantorNo
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please provide phone number of next of kin.'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.photoUrl) {
        validateReg.photoUrl = this.formData.photoUrl
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please upload a profile photo.'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.briefDescription && this.formData.briefDescription.length >= 300) {
        validateReg.briefDescription = this.formData.briefDescription
        this.errorMsg = ''
      } else if (!this.formData.briefDescription) {
        this.errorMsg = 'A valid description of yourself and achievements is required'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      } else {
        this.errorMsg = 'Brief description must be atleast 300 characters in length.'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.country) {
        validateReg.country = this.formData.country
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please select your country'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.state) {
        validateReg.state = this.formData.state
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please select your state'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.address && this.formData.address.length >= 10) {
        validateReg.address = this.formData.address
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Your address is required.'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      // console.log({validateReg})
      // document.getElementById('spinner-survey').style.display = 'block'
      document.getElementById('submitMemberDataBtn').setAttribute('disabled', 'disabled')
      document.getElementById('submitMemberDataBtn').innerHTML = `<i class="fa fa-spinner fa-pulse x2" id="loadIcon"></i> Submitting...`
      try {
        const memData = (await AddService.addMemberData(validateReg)).data
        if (memData) {
          document.getElementById('submitMemberDataBtn').innerHTML = `Submit`
          // document.getElementById('spinner-survey').style.display = 'none'
        }
        this.errorMsg = memData
        this.responseTrigger.open()
        // alert(this.errorMsg)
        setTimeout(() => {
          this.$router.push('/')
        }, 12500)
        return memData
      } catch (error) {
        if (error.response.data) {
          this.errorMsg = error.response.data
          // alert(this.errorMsg)
          this.responseTrigger.open()
          // document.getElementById('spinner-survey').style.display = 'none'
          document.getElementById('submitMemberDataBtn').removeAttribute('disabled')
          document.getElementById('submitMemberDataBtn').innerHTML = `Submit`
        }
      }
    },
    upload (formData) {
      // const url = `http://localhost:7070/handleUploads/member/photo`
      const url = `https://cbt-testing.herokuapp.com/handleUploads/member/photo`
      return axios.post(url, formData)
      // get data
        .then((x) => {
          if (x) {
            this.imgUrl = x.data
            console.log(x.data)
            this.formData.photoUrl = x.data
            return x.data
          }
        })
        .catch(error => {
          this.currentStatus = STATUS_FAILED
          this.failText = error.response.data
          // console.log(error.response.data)
        })
      // // add url field
      //     .then(x => x.map(img => Object.assign({},
      //       img, { url: `http:localhost:3050/public/uploads/${img.id}` })))
    },
    reset () {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    save (formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING

      this.upload(formData)
        .then(x => {
          this.imgUrl = x.data
          this.uploadedFiles = [].concat(x)
          this.currentStatus = STATUS_SUCCESS
          // this.$eventBus.$emit('img-uploaded', {
          //   index: this.id,
          //   url: x.data
          // })
        })
        .catch(err => {
          // console.log({err})
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
        })
    },
    filesChange (fieldName, fileList) {
      // handle file changes
      const formData = new FormData()

      if (!fileList.length) return

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name)
        })

      // save it
      this.save(formData)
    }
  },
  computed: {
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    },
    dropformstyle () {
      if (!this.isSuccess) {
        return {outline: '2px dashed grey'}
      } else {
        return {}
      }
    }
  }
}
</script>

<style>
#memberSurvey > div.surveyForm.row > div.col.s12.m9.white.z-depth-2 {
  margin-top: 1rem;
}
#memberSurvey > div.surveyForm.row > div > div > form > div > div.input-field.col.s12.m6 > label, #memberSurvey > div.surveyForm.row > div > div > form > div > div > label {
  font-size: 1.5rem;
  color: #616161;
}
#memberSurvey > div.surveyForm.row > div > div > form {
  padding: 2rem;
}
#memberSurvey > div.surveyForm.row {
  padding: 2rem
}
div#memberSurvey.memberSurvey .instructionText > ul:nth-child(1) > li {
  padding: 0.6rem;
}
#memberSurvey > div.surveyForm.row > div.col.s12.m9.white.z-depth-2 > div > form > div:nth-child(2) > div.input-field.col.m4.s12 > p > label:nth-child(1) > span [type="radio"]:checked+span:after, [type="radio"].with-gap:checked+span:after {
  background-color: grey;
}
#memberSurvey > div.surveyForm.row > div.col.s12.m9.white.z-depth-2 > div > form > div:nth-child(2) > div.input-field.col.m4.s12 > p > label:nth-child(1) > span [type="radio"]:checked+span:after, [type="radio"].with-gap:checked+span:before, [type="radio"].with-gap:checked+span:after {
  border: 2px solid grey;
}
</style>



// WEBPACK FOOTER //
// src/pmgc/members/survey.vue